import { Button, Group, Stack, StackProps } from '@mantine/core';
import { RawModel } from '@/types/rawModel';
import DownloadIcon from '@/icons/download.svg';
import Link from 'next/link';
import { AssetName } from '../atoms/AssetName';
import { AssetActionColumn } from '../../components/table/columns/assetActionsColumn/AssetActionColumn';
import { CONVERTER_ROW, DCC_IMPORTER_ROW, rawModelToAssetRow } from '../../components/table/hooks/useAssetsTable';
import { OptimisticAssetsAction, useOptimisticAssets } from '../../components/table/hooks/useOptimisticAssets';
import { useSelectedAssetContext } from '../../contexts/SelectedAssetContext';
import { useGrowthbookContext } from '@/app/contexts/GrowthbookContext';

export function RawAssetDetailsHeader({ asset, ...props }: { asset: RawModel } & StackProps) {
  const { dispatchAssetAction } = useOptimisticAssets();
  const { setSelectedAsset, selectedAsset } = useSelectedAssetContext();

  //Hack for importer rows
  const isImporterRow =
    selectedAsset?.basicInfo.rowType === 'output' ||
    selectedAsset?.basicInfo.rowType === CONVERTER_ROW ||
    selectedAsset?.basicInfo.rowType === DCC_IMPORTER_ROW;
  const rowData = isImporterRow ? selectedAsset : rawModelToAssetRow([], false)(asset);

  const handleDelete = (action: OptimisticAssetsAction) => {
    dispatchAssetAction(action);
    setSelectedAsset(undefined);
  };

  const growthbook = useGrowthbookContext();

  const apiUrl = process.env.NEXT_PUBLIC_API_URL;

  return (
    <Stack gap='xs' {...props}>
      <Group justify='space-between'>
        <AssetName id={asset.id} name={asset.name} isOutput={false} disabled={isImporterRow} />
        <AssetActionColumn
          row={{
            original: rowData,
            getIsSelected: () => false,
            toggleSelected: () => null,
          }}
          onAssetDelete={handleDelete}
        />
      </Group>
      {growthbook?.isOn('show-qc-report') && asset.format === 'max' ? (
        <Group>
          <Button
            variant='default'
            leftSection={<DownloadIcon />}
            component={Link}
            href={`${apiUrl}/rawmodel/${asset.id}/rapidqc/report`}
            target='_blank'
            w=''
          >
            QC Tools Report
          </Button>
        </Group>
      ) : null}
    </Stack>
  );
}
